module.exports = __webpack_public_path__ + "img/ribon1.3a04bbb2.png";